import { render, staticRenderFns } from "./CartOrderRecord.vue?vue&type=template&id=2ebb9d6c&scoped=true&"
import script from "./CartOrderRecord.vue?vue&type=script&lang=js&"
export * from "./CartOrderRecord.vue?vue&type=script&lang=js&"
import style0 from "./CartOrderRecord.vue?vue&type=style&index=0&id=2ebb9d6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebb9d6c",
  null
  
)

export default component.exports